module.exports = __webpack_public_path__ + "img/cwm_logo.677a566a.svg";